<template>
  <div>
    <PageHead title="报销年度列表"></PageHead>
    <div class="oa-layout-content">
      <!-- 第一行查询条件 -->
      <div class="search-flex">
        <div class="query-top-select">
          <div class="query-cont">
            <div class="query-view">
              <div class="query-view-lable">报销职工姓名：</div>
              <a-input
                allowClear
                class="w200"
                placeholder="请输入姓名或身份证号"
                v-model="queryForm.fullName"
              />
            </div>
            <div class="query-view">
              <div class="query-view-lable">报销年度：</div>
              <a-select
                allowClear
                placeholder="请选择报销年度"
                class="w200"
                v-model="queryForm.year"
              >
                <a-select-option
                  v-for="(item, index) in yearList"
                  :key="index"
                  :value="item"
                  >{{ item + '年度' }}</a-select-option
                >
              </a-select>
            </div>

            <div class="query-view">
              <div class="query-view-lable">核算状态：</div>
              <a-select
                allowClear
                placeholder="不限"
                class="w200"
                v-model="queryForm.formStatus"
              >
                <a-select-option :value="1">未核算</a-select-option>
                <a-select-option :value="2">已核算</a-select-option>
              </a-select>
            </div>
          </div>
        </div>
        <div class="search-flex-itemm">
          <a-button type="primary" @click="subMit" :loading="loading">
            查询</a-button
          >
          <a-button :style="{ marginLeft: '8px' }" @click="cancel()">
            取消
          </a-button>
        </div>
      </div>
      <blank height="12"> </blank>
      <!-- 查询按钮之下 -->
      <div class="search-flex">
        <div class="query-top-select">
          <div class="query-cont">
            <div class="query-view">
              <div class="query-view-lable">核算时间：</div>
              <a-range-picker
                allowClear
                class="w200"
                v-model="timeHorizon"
                :valueFormat="dateFormat"
              >
                <a-icon slot="schedule" type="smile"
              /></a-range-picker>
            </div>
            <div class="query-view">
              <div class="query-view-lable">部门：</div>
              <a-tree-select
                allowClear
                v-model="organizationId"
                style="width: 360px"
                multiple
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                :tree-data="treeData"
                placeholder="请选择部门"
                tree-default-expand-all
                :replaceFields="{
                  key: 'id',
                  value: 'id',
                  children: 'treeList',
                  title: 'organizationName'
                }"
              >
              </a-tree-select>
            </div>
          </div>
        </div>
      </div>

      <div class="mb20 search-btns mt20">
        <a-button
          type="primary"
          :style="{ marginLeft: '8px' }"
          @click="showModal()"
          icon="swap"
          class="mr10"
        >
          导入</a-button
        >
        <a-button
          type="primary"
          :loading="exportLoading"
          @click="handleExport"
          icon="plus"
        >
          导出</a-button
        >
        <span class="statistics"> 检索统计： {{ total }} 条 </span>
      </div>
      <a-table
        :pagination="false"
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :row-key="(record) => record.id"
      >
        <!-- 序号 -->
        <span slot="index" slot-scope="text, record, index">
          {{ index + 1 + (queryForm.page - 1) * 10 }}
        </span>
        <!-- 年度 -->
        <span slot="year" slot-scope="text"> {{ text }}年度 </span>
        <!-- 报销总金额 已核算才会展示 未核算显示为空 -->
        <div slot="totalFee" slot-scope="text, record">
          <span v-if="record.fromState == 2">{{ record.totalFee }}</span>
        </div>
        <!-- 核算状态 -->
        <div slot="totalFee" class="statusDiv" slot-scope="text, record">
          <span v-if="record.fromState == 2"> {{ record.totalFee }}</span>
        </div>
        <!-- 核算状态 -->
        <div slot="fromState" class="statusDiv" slot-scope="text">
          <div v-if="text == 1" class="dot0 mr5"></div>
          <div v-if="text == 2" class="dot1 mr5"></div>
          <span v-if="text == 1"> 未核算</span>
          <span v-if="text == 2"> 已核算 </span>
        </div>
        <!-- 操作 -->
        <div slot="action" slot-scope="text, record">
          <a-button type="link" class="btn-link" @click="goDetail(record, 1)">
            查看
          </a-button>
        </div>
      </a-table>
      <div class="pagination">
        <a-pagination
          :current="queryForm.page"
          :default-current="queryForm.page"
          :total="total"
          :pageSize="queryForm.size"
          @change="pageChange"
        />
      </div>
    </div>
    <a-modal v-model="visible" title="批量操作" :footer="null">
      <prompts>
        操作步骤
        <span slot="two">
          1. 选择模板和年度,此选项为必填。 2. 填写信息到Excel模版。 3.
          将填写好信息的Excel回传到系统<blank height="8"> </blank
        ></span>
      </prompts>
      <div
        class="mt20"
        style="
          padding: 0 25px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
        "
      >
        <div class="">请选择导入模板<span class="required">*</span>：</div>
        <a-select
          allowClear
          placeholder="请选择导入模板"
          class="w200 ml20"
          v-model="type"
        >
          <a-select-option
            v-for="(item, index) in typeList"
            :key="index"
            :value="item.value"
            >{{ item.name }}</a-select-option
          >
        </a-select>
      </div>
      <div
        class="mt20"
        style="
          padding: 0 25px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
        "
      >
        <div class="query-view-lable">
          请选择导入年度<span class="required">*</span>：
        </div>
        <a-select
          allowClear
          placeholder="不限"
          class="w200 ml20"
          v-model="importYear"
        >
          <a-select-option
            v-for="(item, index) in importYearList"
            :key="index"
            :value="item"
            >{{ item + '年度' }}</a-select-option
          >
        </a-select>
      </div>
      <!-- <div class="xlsx">
        <a-icon type="link" />
        住院和门诊总数据.xlsx
      </div>
      <div class="xlsx">
        <a-icon type="link" />
        住院数据.xlsx
      </div> -->
      <div class="xlsx-btn" style="padding-top: 50px">
        <!-- <a-button
          icon="vertical-align-bottom"
          type="primary"
          @click="downTemplate"
        >
          下载模板</a-button
        > -->
        <a-upload
          name="file"
          :multiple="false"
          :headers="headers"
          action="#"
          :fileList="bfileList"
          :showUploadList="false"
          :beforeUpload="beforeUpload"
          @change="uploading"
        >
          <a-button
            icon="vertical-align-top"
            type="primary"
            :disabled="type.length == 0 || importYear.length == 0"
          >
            上传Excel</a-button
          >
        </a-upload>
      </div>
      <blank height="100"> </blank>
    </a-modal>
    <!-- 导入失败 -->
    <a-modal
      v-model="importData"
      title="导入失败"
      @ok="importDataOk"
      :width="600"
    >
      <div class="import-scrollY">
        <div
          class="import-formCont"
          v-for="(i, index) in importList"
          :key="index"
        >
          {{ i }}
        </div>
      </div>
    </a-modal>
    <appfloor></appfloor>
  </div>
</template>
<script>
const columns = [
  {
    title: '序号',
    dataIndex: 'index',
    key: 'index',
    scopedSlots: { customRender: 'index' },
    align: 'center',
    width: 80
  },
  {
    // title: '报销职工姓名',
    title: '姓名',
    dataIndex: 'fullName',
    key: 'fullName',
    ellipsis: true,
    width: 120,
    align: 'left'
  },
  {
    title: '报销年度',
    dataIndex: 'year',
    key: 'year',
    align: 'center',
    width: 160,
    scopedSlots: { customRender: 'year' }
  },
  {
    title: '身份证号',
    dataIndex: 'idCardNumber',
    key: 'idCardNumber',
    ellipsis: true,
    align: 'left'
  },
  // {
  //   title: '门诊实际报销金额（元）',
  //   dataIndex: 'outpatientFinalFee',
  //   key: 'outpatientFinalFee',
  //   ellipsis: true
  // },
  // {
  //   title: '住院实际报销金额（元）',
  //   dataIndex: 'hospitalizationFinalFee',
  //   key: 'hospitalizationFinalFee',
  //   ellipsis: true,
  //   align: 'left'
  // },
  {
    title: '实际报销总金额（元）',
    dataIndex: 'totalFee',
    key: 'totalFee',
    scopedSlots: { customRender: 'totalFee' },
    ellipsis: true,
    align: 'left'
  },
  {
    title: '核算状态',
    dataIndex: 'fromState',
    key: 'fromState',
    scopedSlots: { customRender: 'fromState' },
    ellipsis: true,
    align: 'left'
  },

  {
    title: '核算时间',
    dataIndex: 'examineTime',
    key: 'examineTime',
    ellipsis: true,
    align: 'left'
  },
  {
    key: 'operation',
    scopedSlots: { customRender: 'action' },
    title: '操作',
    width: 80,
    align: 'left'
  }
]
import {
  medicalReimbursementPage,
  reimbursementExport,
  getYear,
  importTemplate,
  importMedicalReimbursement
} from './api/api'
import { mapState, mapActions } from 'vuex'
export default {
  data() {
    return {
      expand: false,
      visible: false,
      queryForm: {
        page: 1,
        size: 10
      },
      data: [],
      columns,
      total: 0,
      yearList: [],
      loading: false,
      exportLoading: false,
      timeHorizon: [], // 核算时间范围
      // dateFormat: 'YYYY-MM-DD',
      dateFormat: 'YYYY.MM.DD',
      bfileList: [],
      headers: {
        Authentication: localStorage.getItem('token')
      },
      type: [],
      typeList: [
        { value: 1, name: '住院和门诊总数据' },
        { value: 2, name: '住院数据' }
      ],
      importYear: [],
      importYearList: [2022, 2021, 2020],
      importList: [],
      importData: false, //导入错误信息
      organizationId: []
    }
  },

  created() {
    this.getorganizeListFn()
    this.getList()
    this.getYearFn()
  },
  computed: {
    ...mapState({
      treeData: (state) => state.app.treeData // 组织机构树
    })
  },
  watch: {
    organizationId: {
      handler(val) {
        if (!this.isEmpty(val)) {
          this.queryForm.organizationId = val.join(',')
        } else {
          this.queryForm.organizationId = ''
        }
      },
      deep: true
    }
  },
  methods: {
    ...mapActions(['getorganizeListFn']),
    showModal() {
      this.visible = true
    },
    // 导出
    handleExport() {
      let params = this.queryForm
      this.exportLoading = true
      reimbursementExport(params).then((response) => {
        this.exportLoading = false
        this.$message.success('导出成功')
        let blob = new Blob([response.data], {
          type: 'application/vnd.ms-excel'
        })
        let fileName = '医药费年度报销.xlsx'
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, fileName)
        } else {
          var link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = fileName
          link.click()
          //释放内存
          window.URL.revokeObjectURL(link.href)
        }
      })
    },
    // 年度下拉
    getYearFn() {
      getYear().then((res) => {
        if (res.data.code == 0) {
          this.yearList = res.data.data
        }
      })
    },
    //取消
    cancel() {
      this.timeHorizon = []
      this.queryForm = {
        page: 1,
        size: 10
      }
      this.organizationId = []
    },
    subMit() {
      this.queryForm.page = 1
      this.getList()
    },
    // 拉取列表
    getList() {
      this.loading = true
      if (this.timeHorizon.length > 0) {
        //选择了时间范围
        this.queryForm.startTime = this.timeHorizon[0]
        this.queryForm.endTime = this.timeHorizon[1]
      } else {
        delete this.queryForm.startTime
        delete this.queryForm.endTime
      }

      medicalReimbursementPage(this.queryForm).then((res) => {
        this.loading = false
        if (res.data.code == 0) {
          this.data = res.data.data
          this.total = res.data.count
        }
      })
    },
    // 查看详情
    goDetail(record) {
      this.$router.push('/YearMedicalFeeDetail?id=' + record.id)
    },
    // 分页器
    pageChange(num) {
      this.queryForm.page = num
      this.getList()
    },
    // 下载模板
    downTemplate() {
      importTemplate().then((response) => {
        // resolve(response.data);
        let blob = new Blob([response.data], {
          type: 'application/vnd.ms-excel'
        })

        let fileName = '报销年度人员模板.xlsx'
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, fileName)
        } else {
          var link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = fileName
          link.click()
          //释放内存
          window.URL.revokeObjectURL(link.href)
        }
      })
    },
    beforeUpload(file, fileList) {
      return false
    },
    // 导入
    uploading(file) {
      this.$message.loading('导入中···', 0)
      let formDataChildren = new FormData()
      formDataChildren.append('file', file.file)
      formDataChildren.append('type', this.type)
      formDataChildren.append('year', this.importYear)
      // let params = {
      //   file: formDataChildren,
      //   type: this.type,
      //   year: this.importYear
      // }
      importMedicalReimbursement(formDataChildren).then((res) => {
        if (res.data.code == 0) {
          this.$message.destroy()
          this.visible1 = false
          this.$success({
            title: '导入成功',
            // JSX support
            okText: '确定',
            content: res.data.msg,
            onOk: () => {
              this.visible = false
              this.page = 1
              this.getList()
            }
          })
        } else if (res.data.code == 2) {
          //
          this.$message.destroy()
          this.importList = res.data.data
          this.importData = true
        }
      })
    },
    importDataOk() {
      this.importData = false
    }
  }
}
</script>
<style lang="scss" scoped>
.search-flex {
  display: flex;
  align-items: flex-start;
  // justify-content: space-between;
  .query-top-select {
    // width: calc(100% - 200px);
    .query-cont {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .query-view {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 20px 20px 0;
        .query-view-lable {
          width: 100px;
          height: 22px;
          color: rgba(0, 0, 0, 0.65);
          font-size: 14px;
          line-height: 22px;
          text-align: right;
          margin-right: 10px;
        }
      }
    }
  }
  .search-flex-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
}
.search-btns {
  position: relative;
  .statistics {
    position: absolute;
    right: 50px;
    font-size: 14px;
  }
}
.statusDiv {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.xlsx {
  width: 204px;
  height: 22px;
  margin: 15px 25px;
  color: rgba(166, 166, 166, 1);
  font-size: 14px;
  line-height: 22px;
  text-align: left;
}
.xlsx-btn {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/views/MedicalFee/yearIndex.vue